import { useState, useEffect } from 'react';
import { BlockPageTemplate } from '@/types/blockPage';

// Dummy data for block page templates
const DUMMY_TEMPLATES: BlockPageTemplate[] = [
  {
    _id: 'template_1',
    name: 'Default Block Page',
    description: 'Standard block page with company branding',
    htmlContent: `
      <div class="block-page">
        <div class="header">
          <h1>Access Restricted</h1>
        </div>
        <div class="content">
          <p>This website has been blocked by your organization's internet policy.</p>
          <p>If you believe this is an error, please contact your administrator.</p>
        </div>
        <div class="footer">
          <button onclick="history.back()" class="retry-btn">Go Back</button>
        </div>
      </div>
    `,
    cssContent: `
      .block-page {
        font-family: Arial, sans-serif;
        max-width: 600px;
        margin: 50px auto;
        padding: 20px;
        text-align: center;
        background: #f8f9fa;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      }
      .header h1 {
        color: #dc3545;
        margin-bottom: 20px;
      }
      .content p {
        color: #6c757d;
        margin-bottom: 15px;
      }
      .retry-btn {
        background: #007bff;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
      }
    `,
    isActive: true,
    _creationTime: Date.now() - 86400000,
    lastModified: '2024-06-05'
  },
  {
    _id: 'template_2',
    name: 'Educational Block Page',
    description: 'Block page designed for educational institutions',
    htmlContent: `
      <div class="edu-block-page">
        <div class="logo">
          <img src="/logo.png" alt="School Logo" />
        </div>
        <h2>Educational Content Filter</h2>
        <p>This content is not appropriate for the educational environment.</p>
        <div class="actions">
          <button class="primary-btn">Request Access</button>
          <button class="secondary-btn">Go Back</button>
        </div>
      </div>
    `,
    cssContent: `
      .edu-block-page {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 20px;
      }
      .logo img {
        max-width: 150px;
        margin-bottom: 30px;
      }
      h2 {
        font-size: 2rem;
        margin-bottom: 20px;
      }
      .actions {
        margin-top: 30px;
      }
      .primary-btn, .secondary-btn {
        margin: 0 10px;
        padding: 12px 24px;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-size: 1rem;
      }
      .primary-btn {
        background: #28a745;
        color: white;
      }
      .secondary-btn {
        background: transparent;
        color: white;
        border: 2px solid white;
      }
    `,
    isActive: false,
    _creationTime: Date.now() - 172800000,
    lastModified: '2024-06-04'
  }
];

export const useBlockPages = () => {
  const [templates, setTemplates] = useState<BlockPageTemplate[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate API call delay
    setTimeout(() => {
      setTemplates(DUMMY_TEMPLATES);
      setIsLoading(false);
    }, 500);
  }, []);

  return {
    templates,
    isLoading,
    refetch: () => {
      setIsLoading(true);
      setTimeout(() => {
        setTemplates(DUMMY_TEMPLATES);
        setIsLoading(false);
      }, 500);
    }
  };
};